import React from 'react';
import PropTypes from 'prop-types';
import PageFilter from '../common/PageFilter';
import PageHeader from '../common/PageHeader';
import { applyFilterOnData, UpdateColumnWithConfiguration } from '../../utils/helper';
import { controlType } from '../../constants/common';
import GridTable from '../common/Table/Table';
import { transitionTrackerListColumns, transitionTrackerList, transitionStatusMaster, transitionTrackerSteps } from '../../constants/MockData';
import { AppBar, Dialog, IconButton, Paper, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { VisibilityOutlined } from '@material-ui/icons';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import CustomizedTimeline from '../common/Timeline/timeline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class TransitionTracker extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      selectedData: [],
      transitionTrackerListData: transitionTrackerList,
      propertyMasterData: this.props.propertyMasterData
    };
  }

  onFilterChange = (selectedData) => {
    const { transitionTrackerListData } = this.state;
    const filteredData = applyFilterOnData([...transitionTrackerListData], selectedData);
    this.setState({ transitionData: filteredData, selectedData });
  };

  renderActionColumn = (cellInfo) => {
    return (
      <>
        <Tooltip title="View timeLine">
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              let trackerTimeLineData;
              if (cellInfo.status === 'completed') {
                trackerTimeLineData = transitionTrackerSteps;
              } else {
                trackerTimeLineData = transitionTrackerSteps;
              }
              this.setState({ opentimeline: true, trackerTimeLineData: trackerTimeLineData });
            }}
          >
            <VisibilityOutlined fontSize="small" size="small" />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  render () {
    return (<>
 <PageHeader title="Property Transition Tracker" actionsConfig={[
   {
     icon: <ArrowBackIcon size="small" className="back-button" />,
     onClick: () => { this.props.onViewChange(); },
     name: ''
   }
 ]}
              ></PageHeader>
            <PageFilter
              autoFilter={false}
              filterAlwaysVisible={true}
              onFilterChanged={this.onFilterChange}
              filterConfig={[
                {
                  multiple: false,
                  type: controlType.DropDown,
                  source: this.state.propertyMasterData,
                  key: 'propertyName',
                  placeholder: 'Search Property',
                  title: 'Property Name'
                },
                {
                  multiple: false,
                  type: controlType.DropDown,
                  source: transitionStatusMaster,
                  key: 'status',
                  placeholder: 'Status',
                  title: 'status'
                }
              ]}
              gridColumn={3}
              selectedData={this.state.selectedData}
            ></PageFilter>
 <div className="row table-list-container">
              <GridTable
                columns={UpdateColumnWithConfiguration(transitionTrackerListColumns, [])}
                data={this.state.transitionTrackerListData}
                  renderActionColumn={this.renderActionColumn}
              ></GridTable>
            </div>
    {this.state.opentimeline && (
          <Dialog open={this.state.opentimeline} maxWidth="lg">
        <AppBar style={{ position: 'relative', backgroundColor: '#002f6c' }}>
          <Toolbar>
            <Typography variant="h6" style={{ marginLeft: '10px', flex: '1',color: '#FFFFF' }}>
            Tracker Timeline (DI El Paso Logistics Park Phase I, LP,)
            </Typography>
            <IconButton edge="start" color="inherit" onClick={() => { this.setState({ opentimeline: false }); }} aria-label="close">
              <IoMdCloseCircleOutline />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div><Paper><CustomizedTimeline trackerTimeLineData={this.state.trackerTimeLineData}></CustomizedTimeline></Paper></div>
      </Dialog>
    ) }
    </>
    );
  }
}

TransitionTracker.propTypes = {
  propertyMasterData: PropTypes.array.isRequired,
  serviceTypeMasterData: PropTypes.object
};

export default TransitionTracker;
